import React from 'react'
import PromoList from '../promo_components/promo_list'
import WebSidebar from '../../web_sidebar'
export default function
    () {
    return (
        <div>
            <div className='row'>

                <WebSidebar />


                <div className=''>


                    <PromoList />



                </div>
            </div>




        </div>
    )
}
